import { render, staticRenderFns } from "./AliyunOSS.vue?vue&type=template&id=f9bc7790"
import script from "./AliyunOSS.vue?vue&type=script&lang=js"
export * from "./AliyunOSS.vue?vue&type=script&lang=js"
import style0 from "./AliyunOSS.vue?vue&type=style&index=0&id=f9bc7790&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports